import Base from '#BASE/store/userInfo/userInfo.store';
import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';
import constant from 'BASE/common/lotteryConstant';
export const dailyPayType = constant.DailyPayType;
export const ContractType = constant.ContractType;

export default class extends Base {
    constructor() {
        super();
        this.state.privileges.contractPermission = [];
        this.state.privileges.haveExternalGameContract = undefined;
        this.state.privileges.externalGameDailyPayCreationAllowed = undefined;
        this.state.privileges.externalGameContractCreationAllowed = undefined;
        this.state.privileges.dailyPayCGCreationAllowed = undefined;
        this.state.privileges.sportDailyPayCreationAllowed = undefined;
        this.state.privileges.haveSportGameDailyPay = undefined;
        this.state.privileges.haveProportionalDividend = undefined;
        this.state.privileges.bonusCreationAllowed = undefined;
        this.state.privileges.haveBonusPermission = undefined;
        this.state.privileges.hasShareHolderBonus = undefined;
        this.state.privileges.hasShareHolderBonusExternal = undefined;
        this.state.privileges.hasShareHolderBonusContent = undefined;
        this.state.privileges.hasShareHolderBonusContentExternal = undefined;
        this.state.privileges.haveDailyReward = undefined;
        this.state.privileges.dailyRewardCreationAllowed = undefined;

        // 聊天室設定，固定設定不需要從api拿資料
        this.state.hasChatExternalLink = true;
        this.state.hasChatSiteGroup = false;

        this.actions[actionTypes.USER_INFO_PRIVILEGES_BONUS] = async (context, payload) => {
            context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                contractCreationAllowed: undefined,
                dailyPayCreationAllowed: undefined,
                haveContract: undefined,
                haveDailyPay: undefined,
                dailyPayCGCreationAllowed: undefined,
                haveCGDailyPay: undefined,
                haveExternalGameDailyPay: undefined,
                haveExternalGameContract: undefined,
                dailyPayPermission: [],
                contractPermission: [],
                externalGameDailyPayCreationAllowed: undefined,
                externalGameContractCreationAllowed: undefined,
                sportDailyPayCreationAllowed: undefined,
                haveSportGameDailyPay: undefined,
                haveProportionalDividend: undefined,
                haveBonusWallet: undefined,
                bonusCreationAllowed: undefined,
                haveBonusPermission: undefined,
                directAgentType: undefined,
                hasShareHolderBonus: undefined,
                hasShareHolderBonusExternal: undefined,
                hasShareHolderBonusContent: undefined,
                hasShareHolderBonusContentExternal: undefined,
            });
            if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
                try {
                    let _result = await $.post('/api/BonusPrivileges/Get');
                    const systemRuleRes = await $.post('/api/DailyPay/GetSystemRule');
                    const systemRule = systemRuleRes ? JSON.parse(systemRuleRes.SystemRule) : {};
                    let isDailyRewardEnabled = false;

                    if (_result.directAgentType === 'Formal') {
                        isDailyRewardEnabled = systemRule.IsDailyRewardDividendModeFrontendSignEnabled === true;
                    } else if (_result.directAgentType === 'NoDividend') {
                        isDailyRewardEnabled = systemRule.IsDailyRewardNoDividendModeFrontendSignEnabled === true;
                    }

                    let hasShareHolderBonus = _result.hasShareHolderBonus === true;
                    let hasShareHolderBonusExternal = _result.hasShareHolderBonusExternal === true;
                    let dailyPayCreationAllowed =
                        _result.dailyPayPermission.find((e) => e === dailyPayType.BET_PAY) ||
                        _result.dailyPayPermission.find((e) => e === dailyPayType.EARN_PAY) ||
                        _result.dailyPayPermission.find((e) => e === dailyPayType.LOTTERY) === 0
                            ? true
                            : false;
                    let dailyPayCGCreationAllowed = _result.dailyPayPermission.find((e) => e === dailyPayType.CG_PAY)
                        ? true
                        : false;
                    let externalGameDailyPayCreationAllowed = _result.dailyPayPermission.find(
                        (e) => e === dailyPayType.VIDEO_SLOT
                    )
                        ? true
                        : false;
                    let sportDailyPayCreationAllowed = _result.dailyPayPermission.find((e) => e === dailyPayType.SPORT)
                        ? true
                        : false;
                    let dailyRewardCreationAllowed =
                        (_result.dailyPayPermission.find((e) => e === dailyPayType.DAILY_REWARD) ? true : false) &&
                        isDailyRewardEnabled;
                    let contractCreationAllowed =
                        _result.contractPermission.find((e) => e === ContractType.LOTTERY) === 0 ? true : false;
                    let externalGameContractCreationAllowed = _result.contractPermission.find(
                        (e) => e === ContractType.VIDEO_SLOT
                    )
                        ? true
                        : false;
                    let bonusCreationAllowed =
                        dailyPayCreationAllowed ||
                        sportDailyPayCreationAllowed ||
                        externalGameDailyPayCreationAllowed ||
                        dailyPayCGCreationAllowed ||
                        hasShareHolderBonus ||
                        hasShareHolderBonusExternal ||
                        contractCreationAllowed ||
                        dailyRewardCreationAllowed;
                    let haveBonusPermission =
                        _result.haveDailyPay ||
                        _result.haveCGDailyPay ||
                        _result.haveExternalGameDailyPay ||
                        _result.haveSportGameDailyPay ||
                        _result.haveContract ||
                        _result.haveDailyReward;

                    context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                        isDirectAgent: _result.isDirectAgent,
                        contractCreationAllowed: contractCreationAllowed,
                        dailyPayCreationAllowed: dailyPayCreationAllowed,
                        dailyRewardCreationAllowed: dailyRewardCreationAllowed,
                        dailyPayCGCreationAllowed: dailyPayCGCreationAllowed,
                        haveContract: _result.haveContract,
                        haveDailyPay: _result.haveDailyPay,
                        haveDailyReward: _result.haveDailyReward,
                        haveCGDailyPay: _result.haveCGDailyPay,
                        haveExternalGameContract: _result.haveExternalGameContract,
                        haveExternalGameDailyPay: _result.haveExternalGameDailyPay,
                        dailyPayPermission: _result.dailyPayPermission,
                        contractPermission: _result.contractPermission,
                        externalGameDailyPayCreationAllowed: externalGameDailyPayCreationAllowed,
                        externalGameContractCreationAllowed: externalGameContractCreationAllowed,
                        sportDailyPayCreationAllowed: sportDailyPayCreationAllowed,
                        haveSportGameDailyPay: _result.haveSportGameDailyPay,
                        haveProportionalDividend: _result.haveProportionalDividend,
                        haveBonusWallet: _result.haveBonusWallet,
                        bonusCreationAllowed: bonusCreationAllowed,
                        haveBonusPermission: haveBonusPermission,
                        directAgentType: _result.directAgentType,
                        hasShareHolderBonus: hasShareHolderBonus,
                        hasShareHolderBonusExternal: hasShareHolderBonusExternal,
                        hasShareHolderBonusContent: _result.hasShareHolderBonusContent,
                        hasShareHolderBonusContentExternal: _result.hasShareHolderBonusContentExternal,
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        };
        this.mutations[mutationTypes.USER_INFO_PRIVILEGES_BONUS] = (state, payload) => {
            state.privileges.contractCreationAllowed = payload.contractCreationAllowed;
            state.privileges.dailyPayCreationAllowed = payload.dailyPayCreationAllowed;
            state.privileges.dailyRewardCreationAllowed = payload.dailyRewardCreationAllowed;
            state.privileges.dailyPayCGCreationAllowed = payload.dailyPayCGCreationAllowed;
            state.privileges.haveContract = payload.haveContract;
            state.privileges.haveExternalGameContract = payload.haveExternalGameContract;
            state.privileges.haveDailyPay = payload.haveDailyPay;
            state.privileges.haveDailyReward = payload.haveDailyReward;
            state.privileges.haveCGDailyPay = payload.haveCGDailyPay;
            state.privileges.haveExternalGameDailyPay = payload.haveExternalGameDailyPay;
            state.privileges.dailyPayPermission = payload.dailyPayPermission;
            state.privileges.contractPermission = payload.contractPermission;
            state.privileges.externalGameDailyPayCreationAllowed = payload.externalGameDailyPayCreationAllowed;
            state.privileges.externalGameContractCreationAllowed = payload.externalGameContractCreationAllowed;
            state.privileges.sportDailyPayCreationAllowed = payload.sportDailyPayCreationAllowed;
            state.privileges.haveSportGameDailyPay = payload.haveSportGameDailyPay;
            state.privileges.haveProportionalDividend = payload.haveProportionalDividend;
            state.privileges.haveBonusWallet = payload.haveBonusWallet;
            state.privileges.bonusCreationAllowed = payload.bonusCreationAllowed;
            state.privileges.haveBonusPermission = payload.haveBonusPermission;
            state.privileges.directAgentType = payload.directAgentType;
            state.privileges.hasShareHolderBonus = payload.hasShareHolderBonus;
            state.privileges.hasShareHolderBonusExternal = payload.hasShareHolderBonusExternal;
            state.privileges.hasShareHolderBonusContent = payload.hasShareHolderBonusContent;
            state.privileges.hasShareHolderBonusContentExternal = payload.hasShareHolderBonusContentExternal;
        };
    }
}
